import { getAmountComponentsFromBasePrice } from "repoV2/features/Payments/utils/Payments.utils";
import { useSetPriceSummary } from "../../utils/priceSummaryReducer";

export const useStandardPaymentSummary = (props: {
    totalAmount: number;

    basePrice: number;
    creatorTaxPercentage: number;
    exlyIHFPercentage: number;
    exlyGSTPercentage: number;

    basePriceWOffers: number;

    basePriceWMultiplier: number;

    basePriceWOffersNMultiplier: number;
    totalOrderBumpsValueWithTaxes: number;

    discountOffType: number;
    discountAmount: number;
    discountIncludesGst: boolean;
}) => {
    const {
        totalAmount,

        basePrice,
        creatorTaxPercentage,
        exlyIHFPercentage,
        exlyGSTPercentage,

        basePriceWOffers,

        basePriceWMultiplier,

        basePriceWOffersNMultiplier,
        totalOrderBumpsValueWithTaxes,

        discountAmount,
    } = props;
    /*
    STARTS - amount components for representational purposes
    These parts are only for calculations that dont actually affect the payment amount.
    */

    /*
    Amount representing what user would have to pay if there was no offer.
    Used for showing up striked off prices.
    */
    const { creatorTaxAmount: basePriceCreatorTaxAmount } =
        getAmountComponentsFromBasePrice({
            basePrice,
            creatorTaxPercentage,
            exlyIHFPercentage,
            exlyGSTPercentage,
        });
    const { creatorTaxAmount: basePriceWOffersCreatorTaxAmount } =
        getAmountComponentsFromBasePrice({
            basePrice: basePriceWOffers,
            creatorTaxPercentage,
            exlyIHFPercentage,
            exlyGSTPercentage,
        });
    const { totalAmount: basePriceWMultiplierTotalAmount } =
        getAmountComponentsFromBasePrice({
            basePrice: basePriceWMultiplier,
            creatorTaxPercentage,
            exlyIHFPercentage,
            exlyGSTPercentage,
        });
    const { creatorTaxAmount: basePriceWOffersNMultiplierCreatorTaxAmount } =
        getAmountComponentsFromBasePrice({
            basePrice: basePriceWOffersNMultiplier,
            creatorTaxPercentage,
            exlyIHFPercentage,
            exlyGSTPercentage,
        });

    let representationalDiscount = discountAmount;
    /**
     * Note: In case of discount representational calculationm we always include the tax component while showing to the user
     */
    const { creatorTaxAmount: creatorTaxOnDiscountAmount } =
        getAmountComponentsFromBasePrice({
            basePrice: discountAmount,
            creatorTaxPercentage,
            exlyIHFPercentage,
            exlyGSTPercentage,
        });
    representationalDiscount = discountAmount + creatorTaxOnDiscountAmount;

    /*
    ENDS - amount components for representational purposes
    */

    /**
     * strikeOffAmount will be the sum of 'base price without offers total amount' and
     * 'total order bump amount with taxes'
     * SET - Total amount (inclusive of discounts and offers)
     *       and Strike off amount (exclusive of discounts and offers)
     */
    useSetPriceSummary({
        totalAmount,
        strikeOffAmount:
            basePriceWMultiplierTotalAmount + totalOrderBumpsValueWithTaxes,
    });

    return {
        basePriceCreatorTaxAmount,
        basePriceWOffersCreatorTaxAmount,
        basePriceWOffersNMultiplierCreatorTaxAmount,
        representationalDiscount,
    };
};
